import React from 'react';
//import Flower from './Payout-Lifecycle-and-State.png';
function PayoutLifecycleandState() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>Payout Life cycle and State</h1>
               <hr />
               <p class="mt-30">The payment statuses for Payout platform are explained as below: </p>
               <p class="mt-30"><b>Pending:</b> A payment or transfer of funds that has been initiated by the merchant but is yet to receive a final status from the bank.</p>
               <p class="mt-30">
                  <b>Success:</b> A payment transfer (payout) initiated by the merchant has been successfully credited to the beneficiary's account.
               </p>
               <p class="mt-30">
                  <b>Failed:</b> A payment transfer (payout) initiated by the merchant could not be credited to the beneficiary's account due to reasons like insufficient funds, incorrect beneficiary details, or technical errors.
               </p>
               <p class="mt-30">
                  <b>Reversed:</b> A rare state where a payment is initially considered successful but later couldn't be credited to the beneficiary. The debited amount gets credited back to the merchant's account with a separate credit entry, and the transaction is marked as "reversed."
               </p>
               <p class="mt-30">
                  <b>Success to Failed:</b> A rare case where a bank marks a successful transaction as failed after the reconciliation process.
               </p>
               <p class="mt-30">
                  <b>Scheduled:</b> Merchants can pre-schedule payout transactions in advance for a specific date and time.
               </p>
               <p class="mt-30">
                  <b>Queued:</b> If the merchant initiates a transaction when the balance is low, the transaction will be queued for payout whenever the virtual account gets funded. It is an optional feature.
               </p>
               <img src={process.env.PUBLIC_URL + '/images/tmp_2d73d870-b9b3-4ef5-a571-6a0661a9e266.png'} alt="logo" />
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
     
     
   </div>
</div>
)
}
export default PayoutLifecycleandState